export function formatNPR(amount: number, short = false): string {
  const symbol = short ? 'Rs.' : 'रु.';
  return `${symbol} ${amount.toLocaleString('en-IN')}`;
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-NP', {
    year: 'numeric', month: 'short', day: 'numeric',
  });
}
